module.exports = __webpack_public_path__ + "sc.svg?7b4b06e6611268c6ebf0994eeeabf2a0";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/sc.svg
// module id = 1177
// module chunks = 27